import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import MediaQuery from 'react-responsive';
import 'slick-carousel/slick/slick.css';
import withWeatherData from '../withWeatherData';
import TenDayForecastDay from './TenDayForecastDay';
import './tenDayForecast.scss';
import '../carousel.scss';

const {
  i18n: {
    __,
  },
} = wp;

class TenDayForecast extends React.PureComponent {
  static defaultProps = {
    componentLabel: __('10 Day Forecast', 'nbc'),
  };

  static propTypes = {
    componentLabel: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({
      day: PropTypes.string,
      sky: PropTypes.string,
      hiTemp: PropTypes.string,
      loTemp: PropTypes.string,
      iconCode: PropTypes.string,
      precip: PropTypes.string,
      conditions: PropTypes.string,
    })).isRequired,
  };

  days = () => {
    const { data } = this.props;
    return data.map((day, idx) => (
      <TenDayForecastDay
        key={`${day.day}-${day.conditions}`}
        day={day.day}
        idx={idx}
        sky={day.sky}
        hiTemp={day.hiTemp}
        loTemp={day.loTemp}
        iconCode={day.iconCode}
        precip={day.precip}
        conditions={day.conditions}
        onSlideClick={this.moveToSlide}
      />
    ));
  };

  moveToSlide = (idx) => {
    this.slider.slickGoTo(idx);
  };

  render() {
    const { data } = this.props;

    const settings = {
      dots: false,
      arrows: true,
      infinite: false,
      draggable: true,
      swipeToSlide: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      variableWidth: true,
      useCSS: true,
      useTransform: false,
    };

    return (
      <Fragment key="tenDay__wrapper">
        {!! data.length && (
          <div className="tenDay__wrapper">
            <h2 className="tenDay__label">
              {this.props.componentLabel}
            </h2>
            <div className="tenDay__days">
              <div className="radar-open">
                {this.days()}
              </div>
              <MediaQuery maxWidth={1024}>
                {this.days()}
              </MediaQuery>
              <MediaQuery minWidth={1025}>
                <Slider
                  ref={(slider) => { this.slider = slider; }}
                  {...settings}
                >
                  {this.days()}
                </Slider>
              </MediaQuery>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

const wrapWithWeatherData = withWeatherData('tenDay');
export default wrapWithWeatherData(TenDayForecast);
